// Styles
import { GiGearHammer } from "react-icons/gi";
import { Wrapper } from "./styles";

export default function Conta() {
  return (
    <Wrapper>
      <div className="icone">
        <GiGearHammer fontSize="40px" />
      </div>
      <p>Desculpe, ainda estamos em construção!</p>
    </Wrapper>
  );
}
